import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import { convertKPIHistogramResponse, formatKPIScatterResponse } from './analyticsAPIUomHelper';

class Analyics {

    static getHistogramV2Config(assetId) {
        const endpoint = formatEndpoint(endpoints.analytics.HistogramV2Config, { assetId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static getHistogramV2Data(assetKPITypes, from, to) {
        const endpoint = formatEndpoint(endpoints.analytics.HistogramV2Data, { from, to });
        return RestManagerWithoutBaseUrl
            .post(endpoint, assetKPITypes)
            .then(convertKPIHistogramResponse);
    }

    static getScatterV2Config(assetId) {
        const endpoint = formatEndpoint(endpoints.analytics.ScatterV2Config, { assetId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static getScatterV2Data(assetKPITypes, from, to) {
        const endpoint = formatEndpoint(endpoints.analytics.ScatterV2Data, { from, to });
        return RestManagerWithoutBaseUrl
            .post(endpoint, assetKPITypes)
            .then(formatKPIScatterResponse);
    }
}
export default Analyics;
